/* eslint-disable */
import Vue from 'vue'

import moment from 'moment-timezone'
require('moment/locale/es')

Vue.use(require('vue-moment'), moment)

class OcularMoment {
  getDate = (date:any, locale:any = false) => {
    if (locale) {
      moment.locale(locale)
    }
    const data = moment(date)
    return data
  }

  timeZoneDate = (date: any, locale: any = false) => {
    if (locale) {
      moment.locale(locale)
    }
    // .format('YYYY/MM/DD HH:mm:ss')
    const newDate = moment(date).format('YYYY/MM/DD HH:mm:ss')
    const timeZoneDate = moment.tz(newDate, Intl.DateTimeFormat().resolvedOptions().timeZone)
    return timeZoneDate
  }

  formatDate = (date: any, format: string = 'YYYY/MM/DD HH:mm:ss', locale: any = false) => {
    if (locale) {
      moment.locale(locale);
    }

    return moment(date).format(format);
  }
}

const ocularMoment = new OcularMoment()
Vue.prototype.$ocularMoment = ocularMoment
export default ocularMoment
